module.exports = __webpack_public_path__ + "static/media/mongo.554c7d4b.svg";